import React from 'react';
import { useTheme } from '@mui/system';
import {
  ItemContainer,
  EmailLink,
  iconStyle,
  Name,
  UserEmail
} from './style';

const RecipientFieldItem = ({ optionProps, label, data, change, name, ...rest }) => {
  const theme = useTheme();
  const { key, ...otherOptionProps } = optionProps;
  // getOptionDisabled does not work properly
  if (otherOptionProps['aria-disabled']) {
    otherOptionProps.onClick = () => {};
    otherOptionProps.onMouseMove = () => {};
    otherOptionProps.onTouchStart = () => {};
  }
  return (
    <ItemContainer key={key} {...otherOptionProps}>
      <Name>
        <rest.icon style={iconStyle(theme)} />
        {`${label}${data.companyName ? `, ${data.companyName}` : ''}`}
      </Name>
      <UserEmail>
        {data.email}
      </UserEmail>
      {!data.email ?
        <EmailLink
          onClick={e => {
            // prevent select
            e.stopPropagation();
            // push user to search again (refetch data)
            change(name, null);
          }}
          target="_blank"
          href={data.type === 'user' ? `/user/${data.id}` : `/addressbook/contact/edit/${data.id}`}
        >
          Add email
        </EmailLink> : null}
    </ItemContainer>
  );
};

export default RecipientFieldItem;
